/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Select_Folder_TitleInputs */



/**
* | output |
* | --- |
* | "Automatic Backup - Select Folder" |
*
* @param {Options_Backup_Select_Folder_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_select_folder_title = /** @type {((inputs?: Options_Backup_Select_Folder_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Select_Folder_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sauvegarde automatique - Sélectionner un dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Datensicherung – Ordner auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Backup automatico - Seleziona cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое резервное копирование — выберите папку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copia de seguridad automática: seleccionar carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动备份 - 选择文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動バックアップ - フォルダを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित बैकअप - फ़ोल्डर चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cópia de segurança automática - Selecionar pasta")
	return /** @type {LocalizedString} */ ("Automatic Backup - Select Folder")
});